import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from '../button/button.component';

@Component({
  selector: 'app-dialog',
  imports: [Button],
  templateUrl: './app-dialog.html',
  styleUrls: ['./app-dialog.scss'],
})
export class AppDialog {
  @Input() show = true;
  @Input() title?: string;
  @Input() message?: string;
  @Input() actionLabel?: string;
  @Input() number?: string;
  @Output() readonly exit = new EventEmitter<void>();
  @Output() readonly action = new EventEmitter<void>();

  onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('dialog-backdrop')) {
      this.exit.emit();
    }
  }

  onActionClick() {
    this.exit.emit();
  }
}
